export default "__VITE_ASSET__DJiVxcPt__"